/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { Configuration } from '../configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiOAuthApplicationsGet } from '../fn/o-auth-applications/api-o-auth-applications-get';
import { ApiOAuthApplicationsGet$Params } from '../fn/o-auth-applications/api-o-auth-applications-get';
import { apiOAuthApplicationsIdDelete } from '../fn/o-auth-applications/api-o-auth-applications-id-delete';
import { ApiOAuthApplicationsIdDelete$Params } from '../fn/o-auth-applications/api-o-auth-applications-id-delete';
import { apiOAuthApplicationsIdGet } from '../fn/o-auth-applications/api-o-auth-applications-id-get';
import { ApiOAuthApplicationsIdGet$Params } from '../fn/o-auth-applications/api-o-auth-applications-id-get';
import { apiOAuthApplicationsIdPut } from '../fn/o-auth-applications/api-o-auth-applications-id-put';
import { ApiOAuthApplicationsIdPut$Params } from '../fn/o-auth-applications/api-o-auth-applications-id-put';
import { apiOAuthApplicationsIdRegenerateSecretPost } from '../fn/o-auth-applications/api-o-auth-applications-id-regenerate-secret-post';
import { ApiOAuthApplicationsIdRegenerateSecretPost$Params } from '../fn/o-auth-applications/api-o-auth-applications-id-regenerate-secret-post';
import { apiOAuthApplicationsPost } from '../fn/o-auth-applications/api-o-auth-applications-post';
import { ApiOAuthApplicationsPost$Params } from '../fn/o-auth-applications/api-o-auth-applications-post';
import { CreateOAuthApplicationResult } from '../models/create-o-auth-application-result';
import { OAuthApplicationDto } from '../models/o-auth-application-dto';
import { RegenerateClientSecretResult } from '../models/regenerate-client-secret-result';


/**
 * User-owned OAuth applications backed by Keycloak clients. Support the
 * authorization_code flow: a space owner registers an application, receives
 * client_id + client_secret (one-time), and end users of that application
 * then sign in with their SpeakNode account to get access and refresh tokens.
 */
@Injectable({ providedIn: 'root' })
export class OAuthApplicationsService extends BaseService {
  constructor(config: Configuration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiOAuthApplicationsGet()` */
  static readonly ApiOAuthApplicationsGetPath = '/api/OAuthApplications';

  /**
   * Lists OAuth applications in the current space.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOAuthApplicationsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiOAuthApplicationsGet$Response(params?: ApiOAuthApplicationsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OAuthApplicationDto>>> {
    const obs = apiOAuthApplicationsGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Lists OAuth applications in the current space.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiOAuthApplicationsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiOAuthApplicationsGet(params?: ApiOAuthApplicationsGet$Params, context?: HttpContext): Observable<Array<OAuthApplicationDto>> {
    const resp = this.apiOAuthApplicationsGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<OAuthApplicationDto>>): Array<OAuthApplicationDto> => r.body)
    );
  }

  /** Path part for operation `apiOAuthApplicationsPost()` */
  static readonly ApiOAuthApplicationsPostPath = '/api/OAuthApplications';

  /**
   * Creates an OAuth application. ClientSecret is returned in the response
   * exactly once — keep it safe.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOAuthApplicationsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiOAuthApplicationsPost$Response(params?: ApiOAuthApplicationsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateOAuthApplicationResult>> {
    const obs = apiOAuthApplicationsPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Creates an OAuth application. ClientSecret is returned in the response
   * exactly once — keep it safe.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiOAuthApplicationsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiOAuthApplicationsPost(params?: ApiOAuthApplicationsPost$Params, context?: HttpContext): Observable<CreateOAuthApplicationResult> {
    const resp = this.apiOAuthApplicationsPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CreateOAuthApplicationResult>): CreateOAuthApplicationResult => r.body)
    );
  }

  /** Path part for operation `apiOAuthApplicationsIdGet()` */
  static readonly ApiOAuthApplicationsIdGetPath = '/api/OAuthApplications/{id}';

  /**
   * Gets a single OAuth application by id. Accessible from any space the
   * current user is a member of.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOAuthApplicationsIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiOAuthApplicationsIdGet$Response(params: ApiOAuthApplicationsIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<OAuthApplicationDto>> {
    const obs = apiOAuthApplicationsIdGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets a single OAuth application by id. Accessible from any space the
   * current user is a member of.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiOAuthApplicationsIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiOAuthApplicationsIdGet(params: ApiOAuthApplicationsIdGet$Params, context?: HttpContext): Observable<OAuthApplicationDto> {
    const resp = this.apiOAuthApplicationsIdGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OAuthApplicationDto>): OAuthApplicationDto => r.body)
    );
  }

  /** Path part for operation `apiOAuthApplicationsIdPut()` */
  static readonly ApiOAuthApplicationsIdPutPath = '/api/OAuthApplications/{id}';

  /**
   * Updates the application name and redirect URIs. Client_id and
   * client_secret are not affected.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOAuthApplicationsIdPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiOAuthApplicationsIdPut$Response(params: ApiOAuthApplicationsIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<OAuthApplicationDto>> {
    const obs = apiOAuthApplicationsIdPut(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates the application name and redirect URIs. Client_id and
   * client_secret are not affected.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiOAuthApplicationsIdPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiOAuthApplicationsIdPut(params: ApiOAuthApplicationsIdPut$Params, context?: HttpContext): Observable<OAuthApplicationDto> {
    const resp = this.apiOAuthApplicationsIdPut$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OAuthApplicationDto>): OAuthApplicationDto => r.body)
    );
  }

  /** Path part for operation `apiOAuthApplicationsIdDelete()` */
  static readonly ApiOAuthApplicationsIdDeletePath = '/api/OAuthApplications/{id}';

  /**
   * Deletes the OAuth application from Keycloak and soft-deletes it locally.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOAuthApplicationsIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiOAuthApplicationsIdDelete$Response(params: ApiOAuthApplicationsIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiOAuthApplicationsIdDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Deletes the OAuth application from Keycloak and soft-deletes it locally.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiOAuthApplicationsIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiOAuthApplicationsIdDelete(params: ApiOAuthApplicationsIdDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiOAuthApplicationsIdDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiOAuthApplicationsIdRegenerateSecretPost()` */
  static readonly ApiOAuthApplicationsIdRegenerateSecretPostPath = '/api/OAuthApplications/{id}/regenerate-secret';

  /**
   * Regenerates the client secret. The previous secret is invalidated
   * immediately in Keycloak. The new secret is returned exactly once.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOAuthApplicationsIdRegenerateSecretPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiOAuthApplicationsIdRegenerateSecretPost$Response(params: ApiOAuthApplicationsIdRegenerateSecretPost$Params, context?: HttpContext): Observable<StrictHttpResponse<RegenerateClientSecretResult>> {
    const obs = apiOAuthApplicationsIdRegenerateSecretPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Regenerates the client secret. The previous secret is invalidated
   * immediately in Keycloak. The new secret is returned exactly once.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiOAuthApplicationsIdRegenerateSecretPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiOAuthApplicationsIdRegenerateSecretPost(params: ApiOAuthApplicationsIdRegenerateSecretPost$Params, context?: HttpContext): Observable<RegenerateClientSecretResult> {
    const resp = this.apiOAuthApplicationsIdRegenerateSecretPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<RegenerateClientSecretResult>): RegenerateClientSecretResult => r.body)
    );
  }

}
